// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8af46ff2","845":"10cae4d5"}[chunkId] + ".chunk.js";
};